import DOMPurify from "dompurify";

export function dompurifyInput(input) {
  // Sanitize input before storing or rendering
  const cleanInput = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  return cleanInput;
}

//Santize html
export function dompurifyHtml(html) {
  // Sanitize HTML content
  const cleanHtml = DOMPurify.sanitize(html);
  return cleanHtml;
}
